import { AgentRunStatus } from '@this+that/models';

import type { AgentConversationsStore, ConversationSlot } from './types';

function isWaitingForUser(slot: ConversationSlot): boolean {
  return slot.activeRun?.status === AgentRunStatus.WAITING_FOR_USER;
}

function hasPendingUserAction(slot: ConversationSlot): boolean {
  return slot.conversation.pendingUserAction === true;
}

function isUnseenSystemConversation(
  slot: ConversationSlot,
  seenSystemAtById: Record<string, number>,
): boolean {
  if (
    slot.conversation.isSystem !== true ||
    slot.conversation.messageCount <= 0
  ) {
    return false;
  }
  const seenAt = seenSystemAtById[slot.conversation.conversationId] ?? 0;
  return slot.conversation.lastMessageAt > seenAt;
}

function needsAttentionRaw(
  slot: ConversationSlot,
  seenSystemAtById: Record<string, number>,
): boolean {
  return (
    isWaitingForUser(slot) ||
    hasPendingUserAction(slot) ||
    isUnseenSystemConversation(slot, seenSystemAtById)
  );
}

export function selectAttentionConversationIds(
  state: AgentConversationsStore,
): string[] {
  const { slots, focusedId, acknowledgedAttentionIds, seenSystemAtById } =
    state;
  const ids: string[] = [];
  for (const [id, slot] of slots) {
    if (id === focusedId) {
      continue;
    }
    if (acknowledgedAttentionIds.has(id)) {
      continue;
    }
    if (needsAttentionRaw(slot, seenSystemAtById)) {
      ids.push(id);
    }
  }
  return ids;
}

export function selectNeedsAttention(state: AgentConversationsStore): boolean {
  const { slots, focusedId, acknowledgedAttentionIds, seenSystemAtById } =
    state;
  for (const [id, slot] of slots) {
    if (id === focusedId) {
      continue;
    }
    if (acknowledgedAttentionIds.has(id)) {
      continue;
    }
    if (needsAttentionRaw(slot, seenSystemAtById)) {
      return true;
    }
  }
  return false;
}
